import {useContext, useEffect} from 'react';
import {FabricInvitationContext} from '~/common/FabricInvitation/context/FabricInvitationContext';
import type {FabricInvitationValidationResponse} from '~/common/FabricInvitation/types';

export const useFormValidations = (
  validation: string,
  onValidate: () => FabricInvitationValidationResponse | null
) => {
  const {setFormValidations} = useContext(FabricInvitationContext);

  useEffect(() => {
    setFormValidations((validations) => ({...validations, [validation]: onValidate}));
  }, [onValidate, setFormValidations, validation]);

  return {};
};
